module.exports = __webpack_public_path__ + "img/1568221742.4c8e58b4.jpg";